<div class="responseWrapper">
  <fieldset class="responseFields">
    <legend>Cooling Conditions</legend>
    <div>
      <span class="configurationInputLabel">Total Capacity:</span>
      <input readonly="readonly" [value]="coolingTotalCapacity" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getCapacityUnits() }}</span>
    </div>
    <div class="configurationDetailRow">
      <span class="configurationInputLabel">Sensible Capacity:</span>
      <input readonly="readonly" [value]="coolingSensibleCapacity" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getCapacityUnits() }}</span>
    </div>
    <div class="configurationDetailRow">
      <span class="configurationInputLabel">Leaving Dry Bulb:</span>
      <input readonly="readonly" [value]="coolingLeavingDryBulb" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
    </div>
    <div class="configurationDetailRow">
      <span class="configurationInputLabel">Leaving Wet Bulb:</span>
      <input readonly="readonly" [value]="coolingLeavingWetBulb" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
    </div>
    <div class="configurationDetailRow">
      <span class="configurationInputLabel">Fluid Flow Rate:</span>
      <input readonly="readonly" [value]="coolingFluidFlowRate" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getFluidFlowUnits() }}</span>
    </div>
    <div class="configurationDetailRow">
      <span class="configurationInputLabel">Fluid Temp Change:</span>
      <input readonly="readonly" [value]="coolingFluidTemperatureChange" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
    </div>
    <div class="configurationDetailRow">
      <span class="configurationInputLabel">Leaving Fluid Temp:</span>
      <input readonly="readonly" [value]="coolingLeavingFluidTemperature" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
    </div>
    @if (!isSureflow() && coolingFluidPressureDrop > 0) {
      <div class="configurationDetailRow">
        <span class="configurationInputLabel">Fluid Press Drop</span>
        <input readonly="readonly" [value]="coolingFluidPressureDrop" class="configurationRatingValueOutput" />
        <span class="configurationRatingUnitLabel">{{ getPressureDropUnits() }}</span>
      </div>
    }
  </fieldset>
</div>
<div class="responseWrapper">
  <fieldset class="responseFields">
    <legend>Heating Conditions</legend>
    <div>
      <span class="configurationInputLabel">Total Capacity:</span>
      <input readonly="readonly" [value]="heatingTotalCapacity" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getCapacityUnits() }}</span>
    </div>
    <div class="configurationDetailRow">
      <span class="configurationInputLabel">Leaving Dry Bulb:</span>
      <input readonly="readonly" [value]="heatingLeavingDryBulb" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
    </div>
    <div class="configurationDetailRow">
      <span class="configurationInputLabel">Fluid Flow Rate:</span>
      <input readonly="readonly" [value]="heatingFluidFlowRate" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getFluidFlowUnits() }}</span>
    </div>
    <div class="configurationDetailRow">
      <span class="configurationInputLabel">Fluid Temp Change:</span>
      <input readonly="readonly" [value]="heatingFluidTemperatureChange" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
    </div>
    <div class="configurationDetailRow">
      <span class="configurationInputLabel">Leaving Fluid Temp:</span>
      <input readonly="readonly" [value]="heatingLeavingFluidTemperature" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
    </div>
    @if (!isSureflow() && heatingFluidPressureDrop > 0) {
      <div class="configurationDetailRow">
        <span class="configurationInputLabel">Fluid Press Drop</span>
        <input readonly="readonly" [value]="heatingFluidPressureDrop" class="configurationRatingValueOutput" />
        <span class="configurationRatingUnitLabel">{{ getPressureDropUnits() }}</span>
      </div>
    }
  </fieldset>
  <fieldset class="responseFields">
    <legend>Electric Heating</legend>
    <div>
      <span class="configurationInputLabel">Leaving Dry Bulb:</span>
      <input readonly="readonly" [value]="electricHeatLeavingDryBulb" class="configurationRatingValueOutput" />
      <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
    </div>
  </fieldset>
</div>
<div class="footer">Ratings may be impacted by the inclusion of SFRs for certain components. Please review with your RSM if you have any questions.</div>
